import script from "./LibraryArticles.vue?vue&type=script&setup=true&lang=ts"
export * from "./LibraryArticles.vue?vue&type=script&setup=true&lang=ts"

import "./LibraryArticles.vue?vue&type=style&index=0&id=44eee2fa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44eee2fa"]])

export default __exports__